var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full"},[_c('slides',{on:{"next":_vm.next,"skip":_vm.next,"leave":_vm.leave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }